import api from '@/plugins/api'
import Store from 'scomponent/src/data/store'
import { AddressModel } from '../models/AddressModel'
import fieldTranslation from '../../../.env.models.json'

export class AddressesStore extends Store<AddressModel> {
  private static instance: AddressesStore = new AddressesStore()

  private constructor() {
    super(AddressModel, fieldTranslation['Address'])
  }

  public static getInstance(): AddressesStore {
    return AddressesStore.instance
  }

  public loadData() {
    api()
      .get('/addresses')
      .then(response => {
        const addresses = AddressesStore.getInstance()
        addresses.removeAll()
        addresses.add(response.data.data)
        this.localPersist()
      })
  }

  private localPersist(): void {
    const addresses = AddressesStore.getInstance()
    localStorage.setItem('addresses', JSON.stringify(addresses.getStore()))
  }
}
